export const BLACK_DOMAINS = [
    'qq.com',
    'gmail.com',
    '163.com',
    '126.com',
    'yeah.net',
    '188.com',
    'vip.163.com',
    'vip.126.com',
    'yahoo.com'
];
